import { Sparkle } from "@phosphor-icons/react";

/**
 * Small violet pill button used to trigger Claude AI actions across the coach UI.
 * Consistent styling — used on Workouts list, Exercise Library, and Client Overview.
 */
export default function AIButton({ label = "AI", onClick, testId, size = "sm", disabled }) {
  const sizes = {
    sm: "px-2.5 py-1 text-[11px] gap-1",
    md: "px-3.5 py-2 text-xs gap-1.5",
  };
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`inline-flex items-center rounded-full bg-gradient-to-r from-[#AF52DE] to-[#7B4BE6] hover:from-[#C46EEB] hover:to-[#9066EF] text-white font-semibold active:scale-95 transition-transform disabled:opacity-50 ${sizes[size]}`}
      data-testid={testId}
    >
      <Sparkle size={size === "sm" ? 11 : 13} weight="fill" />
      {label}
    </button>
  );
}
